import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getItemTitle } from '@cbridge-utils/navigation';
import { CbridgePalette } from '@cbridge-utils/mui-theme';
import { getDrawerSxTransitionMixin } from '../_helpers/transition';
import { INavigationHeaderItemProps } from './NavigationHeaderItem.interface';

export const NavigationHeaderItem: FC<INavigationHeaderItemProps> = (props) => {
  const { navigationItem, hasDrawerTransitions, isFullyExpanded } = props;

  return (
    <Box
      component={'li'}
      sx={{
        px: 1.5,
        py: 0.75,
        background: CbridgePalette.background.h2,
        backgroundImage: 'none',
        boxShadow: 'unset',
        display: 'flex',
        justifyContent: 'space-between',
        ...(hasDrawerTransitions
          ? getDrawerSxTransitionMixin(isFullyExpanded, 'height')
          : {}),
      }}
    >
      <Typography
        variant={'body2'}
        color={'textSecondary'}
        sx={{
          lineHeight: 2,
          textTransform: 'uppercase',
        }}>
        {getItemTitle(navigationItem)}
      </Typography>
      {navigationItem.action && isFullyExpanded ? navigationItem.action : null}
    </Box>
  );
};
